"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKWizardStepTab = void 0;
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// @TODO: fix jsx-a11y
var React = __importStar(require("react"));
var common_1 = require("../../common");
/**
 * Single tab in the wizard header (step progress indicator)
 * @internal
 */
var GKWizardStepTab = /** @class */ (function (_super) {
    __extends(GKWizardStepTab, _super);
    function GKWizardStepTab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.navigateTo = function () {
            _this.props.onNav(_this.props.data.index);
        };
        return _this;
    }
    GKWizardStepTab.prototype.render = function () {
        var _a = this.props, active = _a.active, 
        // Intentionally destructured from otherProps
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        children = _a.children, data = _a.data, stepLabel = _a.stepLabel, subtitle = _a.subtitle, title = _a.title, validNavTarget = _a.validNavTarget, 
        // Intentionally destructured from otherProps
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onNav = _a.onNav, stepCount = _a.stepCount, _b = _a["data-qa"], baseQA = _b === void 0 ? "gk-wizard-tab" : _b, otherProps = __rest(_a, ["active", "children", "data", "stepLabel", "subtitle", "title", "validNavTarget", "onNav", "stepCount", "data-qa"]);
        return (React.createElement("div", __assign({ onClick: this.navigateTo }, (0, common_1.mapDefaultProps)(otherProps, {
            _gkComponentName: "gk-wizard-tab",
            "data-qa": baseQA,
            className: [
                active && "active",
                validNavTarget && "can-nav-to",
                data.isVisited && "visited",
                data.isValid && "valid",
                data.isComplete && "complete",
            ]
                .filter(function (s) { return s; })
                .join(" "),
        })),
            React.createElement("div", { className: "gk-wizard-inner-tab" },
                React.createElement("div", { className: "d-block d-lg-none gk-wizard-step-indicator", "data-qa": baseQA + "--indicator" }, stepLabel || "Step " + (data.index + 1) + " of " + stepCount),
                React.createElement("div", { className: "gk-wizard-step-graphic" },
                    React.createElement("div", { className: "gk-wizard-step-bar" }),
                    React.createElement("div", { className: "gk-wizard-step-badge" }, data.isComplete ? React.createElement("i", { className: "gi check" }) : data.index + 1)),
                React.createElement("div", { className: "gk-wizard-step-title", "data-qa": baseQA + "--title" }, title),
                React.createElement("div", { className: "gk-wizard-step-subtitle", "data-qa": baseQA + "--subtitle" }, subtitle))));
    };
    return GKWizardStepTab;
}(common_1.GKPureComponent));
exports.GKWizardStepTab = GKWizardStepTab;
